import { createFileRoute } from "@tanstack/react-router";
import {
	handleHostedMcpRequest,
	hostedMcpGetResponse,
	hostedMcpOptionsResponse,
} from "@/lib/hosted-mcp";

export const Route = createFileRoute("/mcp")({
	server: {
		handlers: {
			GET: async () => hostedMcpGetResponse(),
			OPTIONS: async () => hostedMcpOptionsResponse(),
			POST: async ({ request }) => handleHostedMcpRequest(request),
		},
	},
});
